// extracted by mini-css-extract-plugin
export var header = "_gg-0";